import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

import { IconComponent } from '../../design-system/components/icon/icon.component';

import { AdopterProfileSummary } from '../adopter-profile-summary.models';
import { PetszelSharedModule } from '../../petszel-shared.module';

@Component({
  selector: 'lib-adopter-profile-summary-edit',
  standalone: true,
  imports: [IconComponent, PetszelSharedModule],
  templateUrl: './adopter-profile-summary-edit.component.html',
  styleUrl: './adopter-profile-summary-edit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdopterProfileSummaryEditComponent {
  readonly adopter = input.required<AdopterProfileSummary>();

  readonly title = input('Edit adopter profile');

  readonly notice = input<string | null>(null);

  readonly isSaving = input(false);

  /*
   * Staff and Shelter determine whether their own forms are
   * valid, dirty, and ready to save.
   */
  readonly saveDisabled = input(false);

  readonly saveLabel = input('Update profile');

  readonly savingLabel = input('Updating profile…');

  readonly cancel = output<void>();

  readonly save = output<void>();

  onSave(): void {
    if (this.isSaving() || this.saveDisabled()) {
      return;
    }

    this.save.emit();
  }
}
